var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewTask',{attrs:{"taskType":"audit_report","docList":['Audit Report']}})
}
var staticRenderFns = []

export { render, staticRenderFns }